module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00282.3a9a22c9.jpg";